import { Box, Theme, Typography } from '@mui/material'
import React from 'react'
import { useHistory } from 'react-router-dom';

export default function SIPCalculatorCard({ data }: { data: any }): JSX.Element {
    const history = useHistory();
    const { pathname } = history.location
    const goToSipCalculator = () => {
        history.push(`${pathname}/sip-calculator`)
    }
    return (
        <Box sx={(theme: Theme) => ({
            border: `1px solid ${theme.palette.text.secondary}B2`,
            borderRadius: '10px',
            padding: '20px',
            position: 'relative',
            minWidth: '250px',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: theme.palette.primary[50],
                border: `2px solid ${theme.palette.primary[100]}`,
            }
        })}
            onClick={goToSipCalculator}
        >
            {/* <Box
                sx={(theme: Theme) => ({
                    position: 'absolute',
                    top: -0.5,
                    right: -0.5,
                    padding: '5px',
                    background: theme.palette.warning[500],
                    borderTopRightRadius: '10px',
                    borderBottomLeftRadius: '6px'
                })}>
                <Typography variant='overline_400' sx={(theme: Theme) => ({
                    color: theme.palette.warning[800]
                })}>Coming soon</Typography>
            </Box> */}
            {data?.icon}
            <Typography variant='body_500' color='text.secondary' mt={1}>
                {data?.label}
            </Typography>
        </Box>
    )
}
